import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch  } from 'react-redux'
import {FetchCaseBrandModel} from '../models/case_study'
import {fetchAPI} from '../api/index';
import { Block } from './Block';
import { fetchDataLocal, getFilterData } from '../actions';
import FilterBar from './FilterBar';
import BtnClose from './shared/BtnClose';
import Loading  from './shared/Loading';

let dataStatic = require('../data/case_study.json');

export const Home = () => {
  const caseStudies = useSelector((state: FetchCaseBrandModel) => state);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  let handleClose = () => {
    setIsOpen(!isOpen);
  }

  useEffect(() => {
    dispatch(fetchDataLocal(dataStatic));
    // console.log(caseStudies, 'caseStudies');
    //  // data server
    // if(caseStudies.case_study === undefined)
    //   fetchAPI(dispatch);

    // if(caseStudies.error !== "")
    //   dispatch(fetchDataLocal(dataStatic));

    // if(caseStudies.case_study.length !== 0)
    //   dispatch(getFilterData(caseStudies.case_study));
    // else
    //   dispatch(getFilterData(dataStatic));

  }, []);

  // useEffect(() => {
  //   // data locate
  //   dispatch(fetchDataLocal(dataStatic));
  //   dispatch(getFilterData(dataStatic));
  // }, []);

  if(caseStudies.case_study === undefined)
    return <Loading />

  return (
    console.log(caseStudies,'caseStudies'),
    
    <React.Fragment>
      <div className={`wrap ${isOpen ? "show" : ""}`}>
        <Block/>
        <FilterBar/>  
        <div className="close-bar">
        {/* <BtnClose close={()=> handleClose()} type={'filter'}/>   */}
      </div>   
      </div>
    </React.Fragment>
  )
}

export default Home;
